import * as CommonFieldIds from "../constants/CommonFieldIds"
import * as StringConstants from "../constants/StringConstants"
import {getCustomGUISettings, shouldShowIds} from "../login/ClientCache";
import {areEqual, getFirstNotEmptyObj, getFirstNotNullObj, isNotEmptyOrNull, isNullOrUndefined} from "./NamaCommon";
import {substringBeforeLast} from "./StringUtils";
import * as Language from "../constants/Language";

export function translateIdInEnglish( id, prefix) {
    let l = dictionary;
    dictionary = window.enDictoinary || {};
    let t = translateId(id,prefix);
    dictionary = l;
    return t;
}


export let locale = 'ar';
export let dictionary = {};
initLocale();
function initLocale() {
    let query = getQueryParams(document.location.search);
    if (query.locale)
        locale = query.locale.toLowerCase();
    if (!window.arDictoinary || !window.enDictoinary)
        window.noNamaServer = true;
    calcDictionary();
}
function calcDictionary() {
    if (locale === 'en')
        dictionary = window.enDictoinary || {};
    else
        dictionary = window.arDictoinary || {};
}
export function getQueryParams(qs) {
    qs = qs.split('+').join(' ');

    let params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
    return params;
}

export function translate(textToTranslate, prefix) {
    if (!textToTranslate)
        return textToTranslate;
    if (shouldShowIds())
        return textToTranslate;
    if (prefix && prefix.length)
        return translateWithFallback(textToTranslate, prefix + "." + textToTranslate);
    else
        return translateWithFallback(textToTranslate, textToTranslate);
}
export function translateWithFallback(fallback, textToTranslate) {
    if (dictionary[textToTranslate])
        return dictionary[textToTranslate];
    if (textToTranslate.includes(".")) {
        textToTranslate = textToTranslate.substring(textToTranslate.indexOf(".") + 1, textToTranslate.length);
        return translateWithFallback(fallback, textToTranslate);
    }
    else {
        return fallback;
    }
    return textToTranslate;
}
export function translateMenuGroup(group) {
    return translateMenu(group.titleId, group.name1, group.name2, group.code);
}
export function translateMenuItem(item) {
    let translation = translateMenu(item.titleId, item.name1, item.name2);
    return translation;
}

export function translateTitledIDWithPrefixesAr(object, idPrefix) {
    if (isEnglish())
        switchLang();
    let txt = translateTitledIDWithPrefixes(object, idPrefix);
    restoreLang();
    return txt;
}

export function translateTitledIDWithPrefixesEn(object, idPrefix) {
    if (isArabic())
        switchLang();
    let txt = translateTitledIDWithPrefixes(object, idPrefix);
    restoreLang();
    return txt;
}

export function translateTitledIDWithPrefixes(object, idPrefix) {
    if (!object)
        return "";
    if (object.title)
        return translateNaMaText(object.title);
    let id = object.id;
    if (!id)
        return "";
    if (idPrefix)
        id = idPrefix + "." + id;
    let lastPart = translateId(id);
    let prefixes = [];
    do {
        id = substringBeforeLast(id, ".");
        if (areEqual(idPrefix, id) || !id || id.indexOf('.') < 0)
            break;
        let str = translateId(id);
        if (str !== id)
            prefixes.unshift(str);
    }
    while (true);
    let translation = lastPart;
    if (isNotEmptyOrNull(prefixes))
        translation = prefixes.join(" - ") + " - " + translation;
    return translation;
}

let originalLang = null;
export function switchLang() {
    if (originalLang === null)
        originalLang = locale;
    if (originalLang === 'en')
        locale = 'ar';
    else
        locale = 'en';
    calcDictionary();
}
export function restoreLang() {
    if (originalLang == null)
        return;
    locale = originalLang;
    calcDictionary();
}
export function translateMenu(titleId, name1, name2, code) {
    if (shouldShowIds())
        return titleId;
    let translation = getName(name1, name2);
    if (!translation)
        translation = translateId(titleId);
    if (!translation)
        translation = code;
    return translation;
}

export function translateIdAr(id) {
    if (isEnglish())
        switchLang();
    let txt = translateId(id);
    restoreLang();
    return txt;
}

export function translateIdEn(id) {
    if (isArabic())
        switchLang();
    let txt = translateId(id);
    restoreLang();
    return txt;
}

export function translateNaMaTextEn(text) {
    if (isArabic())
        switchLang();
    let txt = translateNaMaText(text);
    restoreLang();
    return txt;
}

export function translateNaMaTextAr(text) {
    if (isEnglish())
        switchLang();
    let txt = translateNaMaText(text);
    restoreLang();
    return txt;
}

export function translateNaMaText(text, prefix) {
    if (!text)
        return "";
    if (text.arabicText || text.englishText)
        return getName(text.arabicText, text.englishText);
    return translateId(text.resourceId, prefix);
}

export function translateTitledIdAr(ownerId, titledId) {
    if (isEnglish())
        switchLang();
    let txt = translateTitledId(ownerId, titledId);
    restoreLang();
    return txt;
}

export function translateTitledIdEn(ownerId, titledId) {
    if (isArabic())
        switchLang();
    let txt = translateTitledId(ownerId, titledId);
    restoreLang();
    return txt;
}

export function translateTitledId(ownerId, titledId) {
    if (shouldShowIds())
        return titledId.id;
    if (titledId && titledId.title && (titledId.title.resourceId || titledId.title.arabicText || titledId.title.englishText))
        return translateNaMaText(titledId.title);
    let titleToTranslate = titledId;
    if (titledId.id)
        titleToTranslate = titledId.id;
    if (typeof titleToTranslate == "object")
        return "";
    return translate(titleToTranslate, ownerId);
}

export function selectNameBasedOnLang(arabic, english) {
    return getName(arabic, english)
}

export function getName(arabic, english) {
    return isArabic() ? arabic || english : english || arabic;
}

export function translateId(id, prefix) {
    if (shouldShowIds())
        return id;
    if (!id)
        return "";
    if (shouldShowIds())
        return id;
    return translate(id, prefix);
}

export function translateMessage(msg, ...args) {
    return formatMessage(translateId(msg), ...args);
}

export function formatMessage(msg, ...args) {
    for (let i = 0; i < args.length; i++) {
        let arg = args[i];
        if (isNullOrUndefined(arg))
            arg = "";
        arg = arg + "";
        msg = msg.split("{" + i + "}").join(arg);
    }
    return msg;
}
export function isArabic() {
    return locale !== "en";
}

export function isEnglish() {
    return !isArabic();
}
export function translateRef(ref) {
    if (!ref)
        return "";
    let code = ref[CommonFieldIds.CODE];
    let altCode = ref[CommonFieldIds.ALT_CODE];
    let name1 = ref[CommonFieldIds.NAME1];
    let name2 = ref[CommonFieldIds.NAME2];
    let id = ref[CommonFieldIds.ID];
    let descriptor1 = "";
    let descriptor2 = "";
    if (!getCustomGUISettings().doNotUseDescriptorsInFields) {
        descriptor1 = ref[CommonFieldIds.DESCRIPTOR1];
        descriptor2 = ref[CommonFieldIds.DESCRIPTOR2];
    }
    return getFirstNotEmptyObj(getName(getFirstNotNullObj(descriptor1, name1), getFirstNotNullObj(descriptor2, name2)) || getName(code, altCode), id);
}
export function getListViewTitle(entityType, viewName, layout, menuItem) {
    if (menuItem && menuItem.target.targetEntity === entityType && (menuItem.listViewArTitle || menuItem.listViewEnTitle))
        return getName(menuItem.listViewArTitle, menuItem.listViewEnTitle);

    if (layout) {
        if (layout.title)
            return translateTitledId(entityType, layout);
        let translatedLayoutId = translateLayoutId(layout.id);
        if (translatedLayoutId)
            return translatedLayoutId;
    }
    let translatedLayoutId = translateLayoutId(viewName);
    if (translatedLayoutId != null)
        return translatedLayoutId;
    return translateId(entityType + "s");
}

function translateLayoutId(layoutId) {
    if (shouldShowIds())
        return layoutId;
    if (layoutId && layoutId !== StringConstants.DEFAULT)
        return translateId(layoutId);
    return null;
}

export function currentLanguage() {
    return isArabic() ? Language.Arabic : Language.English;
}